import React from "react";
import { CarouselInjectedProps, WithStore } from "pure-react-carousel";

interface CarouselWatcherProps extends CarouselInjectedProps {
  windowWidth: number;
}

// This fix is required to solve an issue with pure-react-carousel as outlined in this issue
// https://github.com/express-labs/pure-react-carousel/issues/272

class CarouselWatcher extends React.Component<CarouselWatcherProps> {
  componentDidUpdate(prevProps) {
    if (this.props.carouselStore !== prevProps.carouselStore) {
      const state = this.props.carouselStore.getStoreState();
      const maxAllowedSlide = state.totalSlides - state.visibleSlides;
      if (state.currentSlide > maxAllowedSlide) {
        this.props.carouselStore.setStoreState({
          currentSlide: maxAllowedSlide,
        });
      }
    }
  }
  render() {
    return <></>;
  }
}

export const CarouselWatcherDecorated =
  WithStore<CarouselWatcherProps>(CarouselWatcher);
